import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { company, services } from '../data/content';
import { privacyPolicy, termsOfService } from '../data/legal';
import { LegalModal } from './LegalModal';
import { PhoneIcon, MailIcon, GoogleIcon, FacebookIcon } from './icons';
type LegalDoc = 'privacy' | 'terms';
export function Footer() {
  const [openDoc, setOpenDoc] = useState<LegalDoc | null>(null);
  return <footer className="w-full border-t border-navy-700 bg-navy-900 py-12" data-id="element-237" data-mp="3ufjvpz20zku4">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-238" data-mp="38zawx2kd95j">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-239" data-mp="36czunggsbik">
          <div className="lg:col-span-2" data-id="element-240" data-mp="3ldu874b9l61m">
            <div className="flex items-center gap-3" data-id="element-241" data-mp="3qd6pzana3mxc">
              <img src={company.logo} alt="" className="h-12 w-12 object-contain" data-id="element-242" data-mp="3qbvqhn0v91c1" />
              <span className="font-display text-lg font-bold tracking-tight text-white" data-id="element-243" data-mp="29ydvry6nv08u">
                {company.name}
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-navy-200" data-id="element-244" data-mp="3l9adfilcf44f">
              20 years of family-owned excellence in pool plaster, tile, coping, spray deck
              repair, and complete backyard remodels.
            </p>
            <p className="mt-4 text-sm font-semibold text-sky-300" data-id="element-245" data-mp="3v8hpm2gccspy">
              Licensed · Insured · Honest · Trusted
            </p>
            <div className="mt-5 flex flex-wrap gap-3" data-id="element-246" data-mp="3qazrl73v3xwq">
              <a href={company.googleProfileUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 rounded-md border border-navy-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-sky-300 hover:text-sky-200" data-id="element-247" data-mp="81pgvn5hf5bh">
                <GoogleIcon className="h-4 w-4" data-id="element-248" data-mp="cus3tcfr7gip" />
                5.0 stars on Google
              </a>
              <a href={company.facebookUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 rounded-md border border-navy-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-sky-300 hover:text-sky-200" data-id="element-249" data-mp="qub7nt1j85p7">
                <FacebookIcon className="h-4 w-4" data-id="element-250" data-mp="yv93jr68lwup" />
                Follow us on Facebook
              </a>
            </div>
          </div>

          

          <div data-id="element-251" data-mp="13rg2v144oa3o">
            <h2 className="font-display text-sm font-bold uppercase tracking-[0.14em] text-white" data-id="element-252" data-mp="18jr2e2uyhtvp">
              Contact
            </h2>
            <ul className="mt-4 space-y-3" data-id="element-253" data-mp="1ckt20kssc7y7">
              <li data-id="element-254" data-mp="1hkp6sm9b43et">
                <a href={company.phoneHref} className="flex items-center gap-2.5 text-sm text-navy-100 transition-colors duration-150 ease-out hover:text-sky-300" data-id="element-255" data-mp="1hk5y7w5jqrdg">
                  <PhoneIcon className="h-4 w-4 text-sky-300" data-id="element-256" data-mp="1mhpfz61gdma5" />
                  {company.phoneDisplay}
                </a>
              </li>
              <li data-id="element-257" data-mp="3obx11afeistt">
                <a href={company.emailHref} className="flex items-center gap-2.5 break-all text-sm text-navy-100 transition-colors duration-150 ease-out hover:text-sky-300" data-id="element-258" data-mp="3ocgi6ox89d6s">
                  <MailIcon className="h-4 w-4 shrink-0 text-sky-300" data-id="element-259" data-mp="2afn76wxgt9sw" />
                  {company.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-navy-700 pt-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-260" data-mp="21mjy10turj42">
          <p className="text-xs text-navy-300" data-id="element-261" data-mp="1wos1fti9j8tj">
            © {new Date().getFullYear()} {company.name}. All rights reserved.
          </p>
          <nav aria-label="Legal" className="flex items-center gap-5" data-id="element-262" data-mp="2tbn5sqky7blg">
            <button type="button" onClick={() => setOpenDoc('privacy')} className="text-xs font-semibold text-navy-200 underline-offset-4 transition-colors duration-150 ease-out hover:text-sky-300 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-400" data-id="element-263" data-mp="2pcw6qdwx9jvp">
              Privacy Policy
            </button>
            <span className="h-3 w-px bg-navy-700" aria-hidden="true" data-id="element-264" data-mp="13ys024mz0dvf" />
            <button type="button" onClick={() => setOpenDoc('terms')} className="text-xs font-semibold text-navy-200 underline-offset-4 transition-colors duration-150 ease-out hover:text-sky-300 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-400" data-id="element-265" data-mp="2rvr5f9fqaecp">
              Terms of Service
            </button>
          </nav>
        </div>
      </div>

      <AnimatePresence data-id="element-266" data-mp="3bj71rdjupf8u">
        {openDoc && <LegalModal document={openDoc === 'privacy' ? privacyPolicy : termsOfService} onClose={() => setOpenDoc(null)} data-id="element-267" data-mp="3bk8cti0va1qk" />}
      </AnimatePresence>
    </footer>;
}